// Определение цвета сегмента по логике важности и настроя
export const getAudioSegmentColor = (segment) => {
  const markers = segment.dialog_markers || {};
  const sentiment = (markers.sentiment || '').toLowerCase();
  const hasAggression = markers.has_profanity_or_aggression;
  const topics = segment.topics || {};

  // 1. Красный — Конфликт, Агрессия, Маты
  if (hasAggression || sentiment.includes('напряжен') || sentiment.includes('конфликт')) {
    return '#e55353'; // Красный
  }

  // 2. Оранжевый — Негатив или жалобы
  if (sentiment.includes('негатив') || sentiment.includes('жалоб')) {
    return '#f9b115'; // Оранжевый
  }

  // 3. Зеленый — Позитивный настрой
  if (sentiment.includes('позитив')) {
    return '#2eb85c'; // Зеленый
  }

  // 4. Фиолетовый — Личные темы
  if (topics.personal_and_atmosphere) {
    return '#9c27b0'; // Фиолетовый
  }

  // 5. Синий — Стандартный рабочий диалог / Нейтральный
  return '#3399ff'; // Синий
};

export const AUDIO_COLOR_LEGEND = [
  { color: '#e55353', label: 'Агрессия / Конфликт / Ненормативная лексика' },
  { color: '#f9b115', label: 'Напряженный диалог / Претензии' },
  { color: '#2eb85c', label: 'Позитивный настрой / Довольный клиент' },
  { color: '#3399ff', label: 'Рабочее обсуждение (цветы, заказы, смены)' },
  { color: '#9c27b0', label: 'Личные темы (разговоры не про работу)' },
];